import { render, staticRenderFns } from "./DetailRoute.vue?vue&type=template&id=58d465a8&scoped=true&"
import script from "./DetailRoute.vue?vue&type=script&lang=js&"
export * from "./DetailRoute.vue?vue&type=script&lang=js&"
import style0 from "./DetailRoute.vue?vue&type=style&index=0&id=58d465a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d465a8",
  null
  
)

export default component.exports